module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e2123"
    }
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e2213"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Burk_9781418513399_epub_c6_r1#Anch0003",
      "id": "Anch00113"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e2263"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Burk_9781418513399_epub_c8_r1#Anch0023",
      "id": "Anch00315"
    }
  }, [_c('b', [_vm._v("PART 1")]), _c('br'), _c('b', [_vm._v("BUSINESS BY THE BOOK")])])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e2343"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Burk_9781418513399_epub_c9_r1#Anch0043",
      "id": "Anch00517"
    }
  }, [_vm._v("1. A Radical Approach to Business Management")])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e2393"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Burk_9781418513399_epub_c10_r1#Anch0063",
      "id": "Anch00724"
    }
  }, [_vm._v("2. Basic Biblical Minimums")])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e2453"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Burk_9781418513399_epub_c11_r1#Anch0083",
      "id": "Anch00937",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Business Bondage")])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e2503"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Burk_9781418513399_epub_c12_r1#Anch0103",
      "id": "Anch01154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Personal Lifestyle Goals")])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e2553"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Burk_9781418513399_epub_c13_r1#Anch0123",
      "id": "Anch01364",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Biblical Business Goals")])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e2603"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Burk_9781418513399_epub_c14_r1#Anch0143",
      "id": "Anch01585",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Keeping Vows")])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e2653"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Burk_9781418513399_epub_c15_r1#Anch0163",
      "id": "Anch01796",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The Benefits of Counsel")])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e2783"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Burk_9781418513399_epub_c16_r1#Anch0183",
      "id": "Anch019105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Your Business and Your Spouse")])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e2843"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Burk_9781418513399_epub_c17_r1#Anch0203",
      "id": "Anch021115",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("PART 2")]), _c('br'), _c('b', [_vm._v("CRITICAL POLICY DECISIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e2923"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Burk_9781418513399_epub_c18_r1#Anch0223",
      "id": "Anch023117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Leadership: The Foundation for All Your Decisions")])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e3023"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Burk_9781418513399_epub_c19_r1#Anch0243",
      "id": "Anch025125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Hiring Decisions")])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e3073"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Burk_9781418513399_epub_c20_r1#Anch0263",
      "id": "Anch027136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Firing Decisions")])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e3123"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Burk_9781418513399_epub_c21_r1#Anch0283",
      "id": "Anch029147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Justification for Dismissal")])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e3263"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Burk_9781418513399_epub_c22_r1#Anch0303",
      "id": "Anch031161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Management Selection Decisions")])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e3344"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Burk_9781418513399_epub_c23_r1#Anch0324",
      "id": "Anch033172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Employee Pay Decisions")])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e3394"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Burk_9781418513399_epub_c24_r1#Anch0344",
      "id": "Anch035187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Borrowing Decisions")])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e3444"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Burk_9781418513399_epub_c25_r1#Anch0364",
      "id": "Anch037206",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. Lending Decisions")])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e3494"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Burk_9781418513399_epub_c26_r1#Anch0384",
      "id": "Anch039223",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Discounting Decisions")])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e3544"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Burk_9781418513399_epub_c27_r1#Anch0404",
      "id": "Anch041231",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("PART 3")]), _c('br'), _c('b', [_vm._v("YOUR BUSINESS AND YOUR LIFE")])])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e3634"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Burk_9781418513399_epub_c28_r1#Anch0424",
      "id": "Anch043233",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Corporations and Partnerships")])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e3684"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Burk_9781418513399_epub_c29_r1#Anch0444",
      "id": "Anch045247",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Business Tithing")])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e3734"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Burk_9781418513399_epub_c30_r1#Anch0464",
      "id": "Anch047255",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. Retirement Decisions")])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e3784"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Burk_9781418513399_epub_c31_r1#Anch0484",
      "id": "Anch049264",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. Implementing God’s Plan")])]), _vm._v(" "), _c('p', {
    staticClass: "cctc",
    attrs: {
      "id": "d7e3834"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Burk_9781418513399_epub_c32_r1#Anch0504",
      "id": "Anch051269",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Study Guide")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30479012","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Burk_9781418513399_epub_c3_r1.vue
// module id = 63
// module chunks = 0